import { useDispatch, useSelector } from 'react-redux'
import type { ColumnsType } from 'antd/es/table'
import type { ActionCreatorWithPayload } from '@reduxjs/toolkit'
import type { AppState } from '../../store/store'

export function useColumnVisibility<T>(
  allColumns: ColumnsType<T>,
  selector: (state: AppState) => string[],
  setAction: ActionCreatorWithPayload<string[]>
) {
  const dispatch = useDispatch()
  const deselected = useSelector(selector)

  const selectOptions = allColumns
    .map((c) => c.title)
    .filter((t): t is string => typeof t === 'string')
    .map((t) => ({ value: t, label: t }))

  const visibleColumns = allColumns.filter(
    (c) => typeof c.title !== 'string' || !deselected.includes(c.title)
  )

  const setDeselected = (cols: string[]) => {
    dispatch(setAction(cols))
  }

  return { visibleColumns, deselected, setDeselected, selectOptions }
}
